module.exports = __webpack_public_path__ + "static/CircularPro-MediumItalic.9465588f.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-MediumItalic.woff
// module id = 734
// module chunks = 168707334958949